<script>
	import "mini.css/dist/mini-default.min.css"
	import _ from "lodash";
	import Table from "./Table.svelte";
	import spells from "../data/spellist.json";

	let filters = {
		name: null,
		class: null,
		level: null,
		descriptor: null,
		school: null,
		includeLowerLevels: false
	}
	let filteredSpells = [...spells];


	const hasClassLevel = (spell, level, includeLower = false) => {
		const levels = spell.Class.
			split(',').
			map(c => c.split('/').pop())
			.filter(l => {
				if (includeLower) {
					return l <= level;
				}
				return l == level;
			});
		return levels.length > 0;
	};

	const filterSpells = _.debounce(() => {
		console.log("filtering");
		console.log(filters.includeLowerLevels);
		let filtered = [...spells];
		if (filters.name && filters.name.length > 0) {
			const lowercased = filters.name.toLowerCase();
			filtered = filtered.filter(s => s.Name.toLowerCase().includes(lowercased));
		}

		if (filters.class && filters.class.length > 0) {
			const lowercased = filters.class.toLowerCase();
			filtered = filtered.filter(s => s.Class.toLowerCase().includes(lowercased));
		}

		if (filters.school && filters.school.length > 0) {
			const lowercased = filters.school.toLowerCase();
			filtered = filtered.filter(s => s.School.toLowerCase().includes(lowercased));
		}

		if (filters.descriptor && filters.descriptor.length > 0) {
			const lowercased = filters.descriptor.toLowerCase();
			filtered = filtered.filter(s => s.Descriptor.toLowerCase().includes(lowercased));
		}

		if (filters.level && filters.level.length > 0) {
			filtered = filtered.filter(s => hasClassLevel(s, filters.level, filters.includeLowerLevels));
		}

		filteredSpells = filtered;
	}, 300);
</script>

<main>
	<div class="collapse">
		<input type="checkbox" id="collapse-filters" checked aria-hidden="true">
		<label for="collapse-filters" aria-hidden="true">Filters</label>
		<div>
			<form>
				<fieldset>
					<div class="row">
						<div class="col-sm-12 col-md-2">
							<label for="name">Name</label>
						</div>
						<div class="col-sm-12 col-md-3">
							<input type="text" id="name" bind:value={filters.name} placeholder="Search" on:keyup={filterSpells} />
						</div>
						<div class="col-sm-12 col-md-2">
							<label for="class">Class</label>
						</div>
						<div class="col-sm-12 col-md-3">
							<input type="text" id="class" bind:value={filters.class} placeholder="Search" on:keyup={filterSpells} />
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12 col-md-2">
							<label for="school">School</label>
						</div>
						<div class="col-sm-12 col-md-3">
							<input type="text" id="school" bind:value={filters.school} placeholder="Search" on:keyup={filterSpells} />
						</div>
						<div class="col-sm-12 col-md-2">
							<label for="descriptor">Descriptor</label>
						</div>
						<div class="col-sm-12 col-md-3">
							<input type="text" id="descriptor" bind:value={filters.descriptor} placeholder="Search" on:keyup={filterSpells} />
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12 col-md-2">
							<label for="level">Level</label>
						</div>
						<div class="col-sm-12 col-md-3">
							<input type="text" id="level" bind:value={filters.level} placeholder="Search" on:keyup={filterSpells} />
						</div>
						<div class="col-sm-12 col-md-2">
							<label for="includeLowerLevels">Include lower levels</label>
						</div>
						<div class="col-sm-12 col-md-3">
							<input type="checkbox" id="includeLowerLevels" bind:checked={filters.includeLowerLevels} on:change={filterSpells} />
						</div>
					</div>
				</fieldset>
			</form>
		</div>
	</div>
	<Table Title="Spells" Records={filteredSpells} />
</main>
